'use client';

/**
 * TextBlock — labeled prose for rail cards.
 *
 * Cards-everywhere-native primitive. Renders a small uppercase label
 * over a text body in a rounded muted box — same shape the legacy
 * `<TextSection>` produces, but lives under rail-insights/sections/
 * so it doesn't carry the CopilotPanel coupling forward.
 *
 * Auto-hides when text is null/empty.
 *
 * @layer presentation
 * @arch_component_type section
 * @arch_domain copilot / rail-insights
 */

import { text as textStyles } from '@/lib/design/tokens';

interface TextBlockProps {
  text: string | null | undefined;
  label: string;
  italic?: boolean;
}

export function TextBlock({ text, label, italic = false }: TextBlockProps) {
  if (!text) return null;
  return (
    <div>
      <p className={textStyles.eyebrow}>{label}</p>
      <div className="p-2 rounded-lg bg-muted/30 border border-border">
        <p
          className={
            italic
              ? `${textStyles.muted} italic whitespace-pre-wrap`
              : `${textStyles.body} whitespace-pre-wrap`
          }
        >
          {italic ? `“${text}”` : text}
        </p>
      </div>
    </div>
  );
}
